// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"842063db","472":"db12f820","733":"2b7829da","844":"e942dd3e","845":"481b5fe4","922":"b1bd89e7"}[chunkId] + ".css";
};